import React, { useState } from "react";
import { FaUser, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import logo from "../assets/logo1.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  // ✅ Make sure this is defined in your .env file (e.g., REACT_APP_BACKEND_URL=http://localhost:8000)
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const res = await fetch(`${BASE_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const result = await res.json();

      if (!res.ok) {
        setError(result.detail || "Invalid credentials");
        return;
      }

      console.log("✅ Login success:", result);

      const { access_token, role, username: returnedUsername } = result;

      if (!access_token) {
        setError("Authentication failed: No token received.");
        return;
      }

      // ✅ Store token + user info (only in one place)
      login(role, returnedUsername || username, access_token);

      // ✅ Redirect user based on role
      if (role === "admin") {
        navigate("/admin");
      } else if (role === "developer") {
        navigate("/developer");
      } else {
        navigate("/");
      }
    } catch (err) {
      console.error("❌ Login error:", err);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="w-full max-w-md bg-gray-800 p-8 rounded-2xl shadow-2xl">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex justify-center items-center space-x-3">
            <img
              src={logo}
              alt="TaskGovern Logo"
              className="w-10 h-10" 
            />
            <h1 className="text-3xl font-extrabold text-white">TaskGovern</h1>
          </div>
          <p className="text-gray-400 mt-2">Login to continue</p>
        </div>


        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username */}
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Username
            </label>
            <div className="flex items-center px-3 bg-gray-700 rounded-md">
              <FaUser className="text-gray-400 mr-2" />
              <input
                type="text"
                id="username"
                placeholder="Enter username"
                className="w-full py-2 bg-transparent text-gray-100 focus:outline-none"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-300 mb-1"
            >
              Password
            </label>
            <div className="flex items-center px-3 bg-gray-700 rounded-md">
              <FaLock className="text-gray-400 mr-2" />
              <input
                type="password"
                id="password"
                placeholder="Enter password"
                className="w-full py-2 bg-transparent text-gray-100 focus:outline-none"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {/* Error */}
          {error && (
            <p className="text-red-500 text-sm text-center">{error}</p>
          )}

          {/* Submit */}
          <button
            type="submit"
            className="w-full py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold transition duration-300"
          >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
